/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ManualInputs */

const en_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const es_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const fr_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuel`)
};

const de_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell`)
};

const ja_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マニュアル (MT)`)
};

const zh_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动挡`)
};

const ar_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عادي (يدوي)`)
};

const id_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const it_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuale`)
};

const ru_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Механическая`)
};

const pt_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const ko_val_manual = /** @type {(inputs: Val_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수동`)
};

/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Val_ManualInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_manual = /** @type {((inputs?: Val_ManualInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ManualInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_manual(inputs)
	if (locale === "es") return es_val_manual(inputs)
	if (locale === "fr") return fr_val_manual(inputs)
	if (locale === "de") return de_val_manual(inputs)
	if (locale === "ja") return ja_val_manual(inputs)
	if (locale === "zh") return zh_val_manual(inputs)
	if (locale === "ar") return ar_val_manual(inputs)
	if (locale === "id") return id_val_manual(inputs)
	if (locale === "it") return it_val_manual(inputs)
	if (locale === "ru") return ru_val_manual(inputs)
	if (locale === "pt") return pt_val_manual(inputs)
	return ko_val_manual(inputs)
});